import { email, required, requiredIf } from "vuelidate/lib/validators";

const getValidationMessageFromKey = function(key) {
    const data = {
        date: `Please provide withdrawal date`,
        MainReason: `Please provide main reason`,
        studID: `Please provide student ID`,
        studPassHolder: `Please provide student pass holder application`,
        parentName: `Please provide parent name`,
        siSignature: `Please provide signature`,
        RefundFees: `Refundable School Fees is required.`,
        Reason1Text: `Please provide other reason`,
        Reason1: `Could you share why?`,
        // Reason1: `Please provide reason`,
        Reason2Text: `Please provide other reason2`,
        Reason3Text: `Please provide other reason3`,
        SchoolDetails: `Please provide other school name`,
        School: `Please provide school name`,
        SchoolType: `Please provide destination school`,
        Improvement: `Is there anything we can do to improve?`,
        CountryName: `Please provide country name`,
        Email: `Please fill in your email address`,
        Contact: `Please fill in your contact number`,
        isNotice: `Please provide sufficient notice given`
    };
    return data[key] ?? `${key} is required.`;
};

/**
 * @return {boolean}
 */
const Reason1Available = function() {
    return this.state?.Reason1 === "Others"  && [
        "The school is not suited for my child"
    ].includes(this.state?.MainReason);
};
/**
 * @return {boolean}
 */
// const Reason2Available = function() {
//     return this.state?.Reason2 === "Others";
// };
// /**
//  * @return {boolean}
//  */
// const Reason3Available = function() {
//     return this.state?.Reason3 === "Others";
// };

const is0RefundPercentage = function() {
    return this.state?.RefundFeesPercentage !== "0";
};

const schoolAvailable = function() {
    return this.state?.School === "Others";
};

const schoolNeeded = function() {
    return [
        "The school is not suited for my child"
    ].includes(this.state?.MainReason);
};

const schoolDetailNeeded = function() {
    return this.state?.School === "Other" && [
        "The school is not suited for my child"
    ].includes(this.state?.MainReason);
};

const Reason1Needed = function(){
    // return [
    //     "Enrolling in another local/international Pre-School",
    //     "Enrolling in another international Primary",
    //     "Enrolling in another international Secondary",
    // ].includes(this.state?.MainReason);
    return this.state?.MainReason !== "Graduation"
}

const countryNameRequired = function(){
    return [
        "Repatriating to home country",
        "Relocation to another country",
    ].includes(this.state?.MainReason);
}

const sharedValidations = {
    StudentName:{ required},
    StudentPass: { required },
    Reason1: { requiredIf: requiredIf(Reason1Needed) },
    CountryName:{requiredIf: requiredIf(countryNameRequired)},
    School: { requiredIf: requiredIf(schoolNeeded) },
    SchoolType: { requiredIf: requiredIf(schoolNeeded) },
    SchoolDetails: { requiredIf: requiredIf(schoolDetailNeeded) },
}
const ehValidations = {
    state: {
        ...sharedValidations,

        Date: { required },
        StudentNo: { required },
        MainReason: { required },
        Email: { requiredIf: required },
        Contact: { requiredIf: required },
        ParentName: { required },
        ParentSignature: { required },
        Reason1Text: { requiredIf: requiredIf(Reason1Available) },
        Improvement: { required },
        // Reason2Text: { requiredIf: requiredIf(Reason2Available) },
        // Reason3Text: { requiredIf: requiredIf(Reason3Available) },
    }
};
const preValidations = {
    state: {
        ...ehValidations.state,
        BankAccountHolder: {required},
        BankName: {required},
        BankCode: {required},
        BankAccount: {required},
    }
};
const ehValidationsOfficial = {
    state: {
        ...sharedValidations,

        RefundFeesPercentage: { required },
        MainReason: { required },
        RefundFees: { requiredIf: requiredIf(is0RefundPercentage) },
        Reason1Text: { requiredIf: requiredIf(Reason1Available) },
        Improvement: { required },
        // Reason2Text: { requiredIf: requiredIf(Reason2Available) },
        // Reason3Text: { requiredIf: requiredIf(Reason3Available) },
        isNotice:{required}
    }
};

export { getValidationMessageFromKey, ehValidations, ehValidationsOfficial, preValidations };
